import React, { Fragment, useState } from "react";
import { Mui } from "../libraries/material";
import PropTypes from "prop-types";

const createTabs = ({ steps, tabValue }) => {
  let tabs = [],
  tabPanels = [];

  steps.forEach(
    ({ id, tabProps = {}, tabPanelProps = {}, label, Component, tab }, idx) => {
      const tabId = `tab-${id}`;
      const tabPanelId = `tabpanel-${id}`;
      tabs.push(
        <Mui.Tab
          value={tab ?? idx}
          label={label}
          key={tabId + idx}
          id={tabId}
          aria-controls={tabPanelId}
          {...tabProps}
        />
      );
      tabPanels.push(
        <div
          role="tabpanel"
          key={tabPanelId + idx}
          id={tabPanelId}
          aria-hidden={tabValue !== idx}
          aria-labelledby={tabId}
          {...tabPanelProps}
        >
          <Component />
        </div>
      );
    }
  );

  return {
    tabs,
    tabPanels
  }
}

function Tabs(params = {}) {
  const { steps = [], defaultTabIndex, tabWrapperProps = {}, color = 'primary', hide, value, onChange, ...rest } = params;
  const [tabValue, setTab] = useState(defaultTabIndex ?? steps?.[0]?.tab ?? 0);
  const allowParentToControl = !!onChange && typeof onChange === 'function'
  let tabsProps = { ...rest }
  if(allowParentToControl) {
    tabsProps.value = value
    tabsProps.onChange = onChange
  } else {
    tabsProps.value = tabValue
    tabsProps.onChange = (event, newVal) => {
      setTab(newVal);
    }
  }
  const { tabs, tabPanels } = createTabs({ steps, tabValue: tabsProps.value })

  return (
    <Fragment>
      <Mui.Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Mui.Tabs
          indicatorColor={color}
          textColor={color}
          centered
          {...tabsProps}
        >
          {tabs}
        </Mui.Tabs>
      </Mui.Box>
      <Mui.Box
        {...tabWrapperProps}
      >
        {hide ? (tabPanels[tabsProps.value] ?? false) : tabPanels}
      </Mui.Box>
    </Fragment>
  );
}

Tabs.propTypes = {
  hide: PropTypes.bool,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      Component: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.node,
        PropTypes.element,
      ]).isRequired,
    })
  ),
};
export default Tabs;
